import { useEffect } from "react";
import { DEFAULT_DOCUMENT_TITLE, formatPageTitle } from "@/constants/pageTitles";

export const useDocumentTitle = (pageName?: string) => {
  useEffect(() => {
    document.title = pageName ? formatPageTitle(pageName) : DEFAULT_DOCUMENT_TITLE;
  }, [pageName]);
};
